const normalizeAccountId = (accountId) => {
  const value = String(accountId ?? '').trim();
  if (!/^\d+$/.test(value)) {
    throw new Error('A valid account is required');
  }
  return value.replace(/^0+(?=\d)/, '');
};

const sameReviewIds = (actual, expected) => (
  Array.isArray(actual)
  && Array.isArray(expected)
  && actual.length === expected.length
  && actual.every((reviewId, index) => reviewId === expected[index])
);

export const buildReviewScope = (accountId) => {
  const normalizedAccountId = normalizeAccountId(accountId);
  return {
    companyNumber: normalizedAccountId,
    account_id: normalizedAccountId,
  };
};

export const canOfferAllLocations = (
  accountLocationCount,
  accessibleLocationCount,
  hasAllModulesAccess,
) => (
  accountLocationCount > 0
  && (
    hasAllModulesAccess === true
    || accessibleLocationCount === accountLocationCount
  )
);

export const buildSelectedReviewPayload = (accountId, selectedReviews) => {
  if (!Array.isArray(selectedReviews)) {
    throw new Error('Selected reviews must be an array');
  }
  return {
    ...buildReviewScope(accountId),
    selectedReviews: [...selectedReviews],
  };
};

export const readSelectedReviewResponse = (payload, accountId) => {
  const expectedAccountId = normalizeAccountId(accountId);
  if (
    !payload
    || Array.isArray(payload)
    || typeof payload !== 'object'
    || String(payload.account_id) !== expectedAccountId
    || !Array.isArray(payload.selectedReviews)
  ) {
    throw new Error('The server returned an invalid review configuration');
  }
  return [...payload.selectedReviews];
};

export const isSelectedReviewSaveSuccess = (
  payload,
  accountId,
  selectedReviews,
) => {
  try {
    return payload?.status === 'success'
      && sameReviewIds(
        readSelectedReviewResponse(payload, accountId),
        selectedReviews,
      );
  } catch (error) {
    return false;
  }
};

export const reviewApiErrorMessage = (error, fallback) => {
  const serverError = error?.response?.data?.error;
  if (typeof serverError === 'string' && serverError.trim()) {
    return serverError.trim();
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
};
